import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-enclosure-grid-reference',
    templateUrl: './enclosure-grid-reference.component.html',
    styleUrls: ['./enclosure-grid-reference.component.scss'],
    standalone: false
})
export class EnclosureGridReferenceComponent {
  @Input() ref: string;
  @Input() zoomLevel: number;
  @Input() selected: boolean;
  @Input() isOnSwitchboardTab: boolean;
}
